var _style, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubsApproval(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    transform: "scale(2)",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    className: "show_show__wrapper__graphic__5Waiy ",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "React") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#231F20;}\n\t.st2{fill:#D1D3D4;}\n\t.st3{fill:#68E1FD;}\n\t.st4{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.5,377.6c0,0,12.5-18.4,15.7-37.1c0,0-25.8,5.2-27,27.3C78.7,395.1,91.5,377.6,91.5,377.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.2,384c-0.4,0-0.8-0.1-1.2-0.2c-3-1.1-4.2-6.3-3.7-16c1.2-22.5,27.4-28,27.7-28c0.3-0.1,0.5,0,0.7,0.2 c0.2,0.2,0.3,0.5,0.2,0.7c-3.2,18.6-15.7,37.2-15.9,37.4l0,0C91.7,378.8,87.8,384,84.2,384z M106.2,341.7 c-5,1.4-24.1,7.7-25.2,26.2c-0.6,11.5,1.3,13.9,2.6,14.4c2.3,0.8,6.1-3.5,7.2-5C91.2,376.6,102.8,359.3,106.2,341.7L106.2,341.7z  M91.5,377.7L91.5,377.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81,378.6c5.4-9,8.3-19.3,8.3-29.7c0-10.3-2.9-20.5-8.3-29.2c0,0-13,13.8-16.7,33.7s4,34.6,10.3,30L81,378.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.2,385c-1,0-1.9-0.3-2.7-0.8c-5.2-3.2-8.8-15.7-6-31c3.7-19.9,16.8-33.9,16.9-34.1c0.2-0.2,0.4-0.3,0.7-0.3 c0.2,0,0.5,0.1,0.6,0.4c5.6,8.9,8.6,19.2,8.5,29.7c0,10.7-2.9,21.1-8.5,30.2c-0.1,0.1-0.1,0.1-0.2,0.2l-6.4,4.7 C74.2,384.6,73.2,385,72.2,385z M80.9,321c-2.7,3.2-12.7,15.7-15.8,32.5c-2.7,14.4,0.7,26.4,5.3,29.3c1.1,0.8,2.7,0.8,3.8-0.1 l6.2-4.6c5.3-8.8,8.1-18.9,8.1-29.2C88.5,339.1,85.8,329.4,80.9,321z M81,378.6L81,378.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.6,383.3c0,0,3.7-24.3-3.7-36.6S46.3,329,46.3,329s-7.9,18.2,0,31.9S70.6,383.3,70.6,383.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.6,384.1c-0.1,0-0.3,0-0.4-0.1c-0.7-0.4-16.8-8.9-24.7-22.7c-8-14-0.4-31.9,0-32.7c0.2-0.4,0.7-0.6,1.1-0.4 c0.6,0.2,13.6,5.6,21.1,18s3.9,36.2,3.8,37.2c0,0.3-0.2,0.5-0.4,0.6C70.9,384.1,70.7,384.1,70.6,384.1z M46.7,330.1 c-1.3,3.6-6.4,18.8,0.3,30.4c6.5,11.4,19.2,19.3,23,21.5c0.6-5,2.5-24.5-3.7-34.9S49.6,331.5,46.7,330.1L46.7,330.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.1,373.2h41L90.8,402c-0.4,2.9-2.9,5-5.8,5H64.2c-2.9,0-5.4-2.1-5.8-5L54.1,373.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85,407.8H64.2c-3.3,0-6.2-2.5-6.7-5.8l-4.2-28.7c0-0.2,0-0.5,0.2-0.7c0.2-0.2,0.4-0.3,0.6-0.3h41 c0.2,0,0.5,0.1,0.6,0.3c0.2,0.2,0.2,0.4,0.2,0.7l-4.2,28.7C91.2,405.4,88.3,407.8,85,407.8z M55.1,374.1l4.1,27.8 c0.4,2.5,2.5,4.3,5,4.3H85c2.5,0,4.6-1.9,5-4.3l4.1-27.8H55.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M458.5,399.8H32c-0.4,0-0.7-0.4-0.6-0.8c0-0.3,0.3-0.6,0.6-0.6h426.5c0.4,0,0.8,0.2,0.8,0.6 c0,0.4-0.2,0.8-0.6,0.8C458.6,399.8,458.6,399.8,458.5,399.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Letter"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M318.3,380.7l-45.9-286c0,0-194.3,0.8-193.5,0l45.9,286C124.8,380.7,320.1,378.9,318.3,380.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317.8,382.3l-0.2-1c-8.3-1.2-129-0.4-192.8,0.2h-0.7l-0.1-0.6L78.2,95L78,94.6l1.4-1.4l0.2,0.9 c8.8,0.5,129,0.2,192.8-0.1h0.6l0.1,0.6L319,380.4l0.2,0.4L317.8,382.3z M79.8,95.5L125.4,380c5.9-0.1,51.1-0.5,95.8-0.7 c28-0.1,50.4-0.2,66.5-0.1c19.9,0.1,27,0.3,29.6,0.6L271.7,95.5c-5.9,0-51.2,0.2-96,0.3c-28.1,0.1-50.4,0.1-66.5,0 C89.4,95.8,82.3,95.8,79.8,95.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 134.1,
    y: 115.3,
    width: 93.8,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 152.8,
    y: 355.2,
    width: 44.2,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 251,
    y: 355.2,
    width: 44.2,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 111.1,
    y: 137.8,
    width: 154.9,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 129.7,
    y: 168.2,
    width: 128.6,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 132.6,
    y: 186.6,
    width: 128.6,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 135.6,
    y: 205.1,
    width: 128.6,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 138.5,
    y: 223.5,
    width: 128.7,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 141.5,
    y: 241.9,
    width: 128.6,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 144.5,
    y: 260.4,
    width: 128.6,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 147.4,
    y: 278.8,
    width: 128.7,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 150.4,
    y: 297.2,
    width: 128.6,
    height: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M172.7,349.6c-7.2,0-13.4-5.2-14.4-12.3l-0.1-0.4c-1.3-8,4.2-15.5,12.2-16.7s15.5,4.2,16.7,12.2v0.4 c1.3,8-4.2,15.5-12.1,16.7C174.2,349.6,173.4,349.6,172.7,349.6L172.7,349.6z M172.6,321.5c-7.2,0-13.1,5.8-13.2,13.1 c0,0.7,0.1,1.4,0.2,2.1l0.1,0.3c1.1,7.2,7.8,12.1,15,11s12.1-7.8,11-15l0,0v-0.3C184.7,326.2,179.1,321.5,172.6,321.5L172.6,321.5z "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "171.6,341.5 162.8,334.6 163.7,333.4 171.3,339.3 180.4,327.1 181.6,328  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M308.1,407.2l-2.7,19.7c0,0,120.4,1.4,118.9,0s0-30.3,0-30.3L308.1,407.2L308.1,407.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M395.1,428.3c-7.9,0-17.8,0-30.4-0.1c-29.3-0.2-59-0.5-59.3-0.5c-0.2,0-0.4-0.1-0.6-0.3 c-0.1-0.2-0.2-0.4-0.2-0.6l2.7-19.7c0-0.3,0.3-0.6,0.7-0.6l116.2-10.6c0.2,0,0.4,0.1,0.6,0.2c0.2,0.1,0.2,0.4,0.2,0.6 c-0.7,13.4-1,28.4-0.2,29.8c0.2,0.2,0.3,0.5,0.1,0.8C424.8,427.8,424.6,428.3,395.1,428.3L395.1,428.3z M423.6,427.2 c0,0.1,0.1,0.2,0.1,0.2C423.7,427.3,423.7,427.3,423.6,427.2L423.6,427.2z M306.2,426.2c44.3,0.5,109.7,1,117.1,0.2 c-0.9-4.2-0.3-19.2,0.1-28.9l-114.8,10.5L306.2,426.2L306.2,426.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M429.8,414.5H303.1c2.3-20.5,13-79,18.5-111.7c3.7-22.2,12.8-40.3,18.7-50.6c2.5-4.4,7.6-7.8,14.3-10.2 c15-5.4,37.7-5.6,55.8-0.1c8.5,2.6,15.9,6.4,21.2,11.5C450.4,271.7,434,386.6,429.8,414.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M289.1,304.8c-5.5-2.7-37-56-37-56l-23,18.9c0.5,3.5,25.9,94.7,49.2,90.4s52.3-35.1,52.3-35.1l19.4-79.1 c0,0-13.2,5.1-22.3,16.3C313.4,277.8,293.1,306.7,289.1,304.8L289.1,304.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M305.4,397.4h-0.1c-0.4-0.1-0.7-0.5-0.6-0.9c0,0,0,0,0,0l19.8-114.9c0.1-0.4,0.5-0.7,0.9-0.6 c0.4,0.1,0.7,0.5,0.6,0.9l-19.8,114.9C306.1,397.1,305.7,397.4,305.4,397.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M434.7,258.1c0.5,1.2,45.9,109.3,22.9,123.5s-94.9,8.7-94.9,8.7l2.9-32l57.7-7.7L434.7,258.1L434.7,258.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.2,359c-0.4,0-0.7-0.3-0.7-0.8c0-0.4,0.3-0.7,0.6-0.7l67.7-10.7c0.4-0.1,0.8,0.2,0.9,0.6 c0.1,0.4-0.2,0.8-0.6,0.9L368.3,359H368.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M426.7,348.3L426.7,348.3c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0c0.2-17.8-4.8-62.8-4.8-63.2 c0-0.4,0.3-0.8,0.7-0.8c0.4,0,0.8,0.3,0.8,0.7c0,0.5,5,45.5,4.8,63.4C427.5,348,427.1,348.3,426.7,348.3L426.7,348.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M248.7,231.3c1.6,2.3,2.5-5.4,2.5-5.4s-3.8-10,0.2-10.4s8.7,12.1,7.1,15.4c-0.9,1.9-4.4,12.8-7,13.7 c0,0,1.8,7.1,1.3,7.9c-1.9,4.3-12.9,11.6-18.4,11.7c-3.4-3.6-5.8-14.5-6.5-14.6c-8.9-1.2-12.6-13.5-11-17 C219.7,226.7,241.8,221.1,248.7,231.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.2,265l-0.2-0.2c-2.3-2.4-4.1-7.9-5.3-11.5c-0.4-1.1-0.8-2.4-1-2.9c-3.8-0.6-7.1-3.2-9.3-7.3 c-2.1-3.9-3-8.5-1.9-10.8c1.6-3.4,8.7-6.6,16.3-7.3s13.6,1.5,16.6,5.8c0.6-1.5,1-3.2,1.2-4.8c-0.5-1.3-2.6-7.4-1-10 c0.4-0.7,1.1-1.1,1.9-1.2c1.4-0.2,2.9,0.8,4.3,2.8c2.7,3.7,4.9,10.9,3.6,13.7c-0.2,0.4-0.5,1.2-0.9,2.3c-2,5.2-3.9,10.1-5.9,11.5 c1.7,6.9,1.2,7.7,1.1,7.9c-1.9,4.3-13.1,11.9-19,12L234.2,265z M235.3,226.4c-0.8,0-1.6,0-2.5,0.1c-7.6,0.6-13.9,3.8-15.1,6.4 c-0.7,1.6-0.2,5.7,1.9,9.4c1.2,2.2,3.9,5.9,8.5,6.5c0.7,0.1,0.9,0.7,1.9,3.9c1.1,3.4,2.8,8.4,4.7,10.7c5.4-0.4,15.7-7.4,17.4-11.2 c0.1-0.6-0.6-4.3-1.4-7.4l-0.2-0.7l0.6-0.2c1.7-0.6,4.4-7.9,5.6-11c0.4-1.1,0.7-2,1-2.4c0.9-1.8-0.7-8.3-3.4-12.2 c-1-1.5-2.1-2.2-2.9-2.2c-0.3,0-0.7,0.2-0.8,0.5c-1,1.6,0.2,6.3,1.2,8.9l0.1,0.2v0.2c-0.5,4-1.3,6.2-2.4,6.4 c-0.6,0.1-1.2-0.2-1.5-0.7l0,0C245.8,228.3,241.2,226.4,235.3,226.4L235.3,226.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    transform: "matrix(0.8366 -0.5478 0.5478 0.8366 -81.1979 175.3444)",
    cx: 253.3,
    cy: 223.8,
    rx: 13.8,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216.8,236.4c-1.5-6.2,7.9-13.2,14.9-18.7c4.2-3.3,8.5-2.3,12.9-0.5c0,0,6.4,2.5,8.2,7.8 c1.4,4.3-1.9,9.1-2.3,10.2c-1.2,3-12.4,10.6-15.6,9.5c-1.9-0.7-3.1-1.8-3.7-5c-1.2-6.3-6.5-5.9-8-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.6,245.6c-0.3,0-0.7,0-1-0.1c-2.4-0.9-3.6-2.4-4.2-5.6c-1-5-4.6-5.4-7.1-5.2l-0.1-0.8v-0.7 c5-0.3,7.9,1.9,8.8,6.4c0.6,3,1.6,3.9,3.2,4.4c2.2,0.8,13.3-5.6,14.6-9.1c0.1-0.2,0.2-0.5,0.4-0.9c0.9-1.8,2.9-5.5,1.8-8.8 c-1.6-4.9-7.7-7.3-7.7-7.3c-4.6-1.9-8.4-2.5-12.1,0.4l-0.7,0.6c-6.8,5.3-15.2,11.8-13.9,17.4l-1.4,0.4c-1.6-6.5,7.3-13.4,14.4-18.9 l0.7-0.6c4.6-3.6,9.3-2.4,13.6-0.6c0.2,0.1,6.8,2.7,8.6,8.3c1.3,3.9-0.9,8-1.9,10c-0.2,0.3-0.3,0.6-0.4,0.8 C250,238.5,240,245.6,235.6,245.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M240.7,220.7c2.8,0.3,5.3,1.8,6.8,4.2c1.8,2.7,1.9,7.1,0.2,13.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M248.4,238.5l-1.4-0.4c1.6-6,1.6-10.3-0.1-12.8c-1.3-2.2-3.6-3.6-6.1-3.9V220c3,0.3,5.8,1.9,7.4,4.5 C250,227.4,250.1,232,248.4,238.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.6,224.1c0,0,6.1,2.4,8.3,5.4c1.3,1.8,0.9,10-1.8,13.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.6,243.3l-1.2-0.9c2.5-3.1,2.8-10.9,1.8-12.4c-1.9-2.8-7.9-5.1-7.9-5.1l0.5-1.4c0.3,0.1,6.4,2.5,8.6,5.7 C244.9,231.2,244.4,239.8,241.6,243.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237,245.2l-1.4-0.5c1.2-3.4,1.9-8,0.3-11s-6.9-5.2-6.9-5.2l0.6-1.4c0.2,0.1,5.9,2.5,7.7,5.9 C239.4,237.3,237.6,243.4,237,245.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363.4,382.5l-2.2-0.1c0,0-23.5,7.9-27.6,7.2c-2.3-0.4-4.5-1.7-4.2-3.7c-2.8-0.7-2.8-4-2.1-6 c-2.9-1-3.3-5.7-2.1-7.9c-3.8-4.5-0.7-7.4,1.3-8.7c3.2-2.1,19.7-3.4,19.7-3.4s-1.4-15,0.8-17.5s4.7,2.9,5.8,7 c1.5,5.3,4.3,6.6,5.8,9.5l6.8,0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.1,390.3c-0.2,0-0.5,0-0.7,0c-1.7-0.2-3.2-1-4.2-2.2c-0.3-0.5-0.5-1.1-0.6-1.6c-0.8-0.3-1.5-1-1.9-1.7 c-0.6-1.4-0.7-2.9-0.3-4.4c-1-0.6-1.7-1.5-2.1-2.5c-0.7-1.8-0.7-3.9,0-5.7c-1.2-1.3-1.8-3.1-1.6-4.9c0.4-1.9,1.7-3.5,3.4-4.5 c2.9-1.9,15.7-3.2,19.2-3.5c-0.3-3.7-1-14.9,1-17.3c0.5-0.7,1.3-1,2.2-0.9c2.4,0.5,4.2,5.4,4.9,8.1c0.7,2.4,1.9,4.7,3.7,6.5 c0.7,0.8,1.3,1.6,1.9,2.4l6.5,0.7l-0.2,1.5l-7.2-0.8l-0.2-0.3c-0.5-0.9-1.2-1.8-1.9-2.5c-1.9-2-3.3-4.4-4-7.1 c-0.9-3.5-2.6-6.8-3.8-7c-0.1,0-0.3-0.1-0.7,0.4c-1.4,1.6-1.1,11.3-0.6,17l0.1,0.8l-0.8,0.1c-4.5,0.4-16.8,1.7-19.3,3.3 c-1.4,0.7-2.4,2-2.8,3.4c-0.1,1.5,0.5,3,1.6,4.1l0.3,0.4l-0.2,0.5c-0.7,1.5-0.8,3.3-0.2,4.9c0.3,0.9,1,1.6,1.8,2l0.7,0.2l-0.3,0.7 c-0.5,1.2-0.5,2.6,0,3.8c0.3,0.6,0.9,1,1.5,1.2l0.7,0.2l-0.1,0.7c-0.1,0.4,0,0.8,0.3,1.2c0.8,0.9,2,1.5,3.3,1.6 c3.2,0.5,20.8-5,27.2-7.2h0.1l2.3,0.1l-0.1,1.5l-2-0.1C358.4,384.1,339.5,390.3,334.1,390.3z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 363,
    y1: 388.5,
    x2: 365.5,
    y2: 358.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M363,389.2L363,389.2c-0.5,0-0.8-0.4-0.8-0.8c0,0,0,0,0,0l2.5-30.2c0-0.4,0.4-0.7,0.8-0.7 c0.4,0,0.7,0.4,0.7,0.8c0,0,0,0,0,0l-2.5,30.2C363.7,388.9,363.4,389.2,363,389.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400.6,391.1c-20.1,0-37.2-1.5-37.5-1.5c-0.4,0-0.7-0.4-0.7-0.8s0.4-0.7,0.8-0.7c0.5,0,53.1,4.5,81.7-2.3 c0.4-0.1,0.8,0.1,0.9,0.5c0,0,0,0,0,0c0.1,0.4-0.2,0.8-0.6,0.9C432.8,390.2,415.8,391.1,400.6,391.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M409,211.6c4.3-12.9,5.8-24.4,1.5-37.8c-0.6-2.3-1.8-4.5-3.5-6.2c-1.6-1.4-3-1.1-4.8-1.4 c-2.1-0.3-2.5-0.8-4.5-2.2c-3.4-2.3-7.7-3.1-11.7-3.2c-5.3-0.1-10.7,0.8-16,0.4S359,159,356,154.6c-1.2,4.4,0.1,9,3.4,12.1 c-3.2-0.8-6-2.5-8.1-5.1c-2.1,4-2.2,8.8-0.2,12.9c0.3,0.6,0.6,1.1,0.7,1.8c0.1,0.8,0.1,1.7-0.1,2.5c-0.7,3.4-1,6.8-1,10.2 c0,3.5,1.2,6.8,3.3,9.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363.1,235.6l-2,14.3c0,0,1.6,15.1,16.9,13.2c9.2-1.2,17.3-6.5,22.1-14.4l3.2-33.5c0,0-10.4-7.1-4.5-30.8 c-12.8,3.9-26.3,4.2-39.3,1c0,0-9.7,25.3-9.2,37S363.1,235.6,363.1,235.6L363.1,235.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.9,246.9c0,0,5.8,1.8,13.1-3.7s6.8-10.8,6.8-10.8s-10.2,2.7-18.1,2.6L361.9,246.9L361.9,246.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372.9,201c0,0-8.4,12.3-6.5,14.5s7.5,0.8,7.5,0.8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    transform: "matrix(3.612045e-02 -0.9993 0.9993 3.612045e-02 165.0884 569.5452)",
    cx: 377.8,
    cy: 199.2,
    rx: 3.4,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    transform: "matrix(3.612045e-02 -0.9993 0.9993 3.612045e-02 148.9528 551.5676)",
    cx: 360.4,
    cy: 198.6,
    rx: 3.4,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.4,264c-3.3,0.1-6.5-1-9.1-3c-5.1-4.1-5.9-10.8-5.9-11.1v-0.1l1.9-13.7c-2.8-0.6-12.2-3.2-12.6-13.7 c-0.5-11.8,8.8-36.2,9.2-37.3l0.2-0.6l0.6,0.2c12.8,3.1,26.2,2.8,38.9-1l1.3-0.5l-0.3,1.4c-5.7,22.7,4.1,29.9,4.2,29.9l0.4,0.2v0.4 l-3.2,33.6l-0.1,0.1c-4.9,8.1-13.2,13.6-22.6,14.8C377.3,263.9,376.3,264,375.4,264z M361.9,249.9c0.1,0.8,1,6.5,5.4,10 c2.8,2.2,6.3,3,10.7,2.5c13.9-1.8,20.7-12.6,21.4-13.9l3.1-32.9c-1.8-1.5-9.5-9.3-4.7-30c-12.3,3.4-25.3,3.7-37.8,0.8 c-1.5,3.9-9.3,25.6-8.9,36.1c0.5,11,11.6,12.4,12.1,12.4l2.1,0.2l-1.5,1L361.9,249.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M394.6,207.8c1.4-1.9,3.1-3.5,5-4.7c1-0.7,2.3-1.1,3.5-1.1c1,0.1,2,0.5,2.8,1.2c2.5,1.8,4,4.6,4.3,7.6 c0.1,1.4,0,2.8-0.6,4.1c-1,2-2.6,3.6-4.6,4.5c-2,0.9-4.1,1.6-6.3,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399,222.1c-0.4,0-0.7-0.2-0.8-0.6c-0.1-0.4,0.1-0.8,0.5-0.9c0,0,0,0,0,0c2.1-0.4,4.1-1,6.1-1.9 c1.9-0.8,3.4-2.3,4.2-4.1c0.5-1.2,0.7-2.5,0.5-3.7c-0.3-2.8-1.7-5.4-4-7.1c-0.7-0.6-1.5-0.9-2.4-1c-1.1,0-2.2,0.4-3.1,1 c-1.9,1.2-3.5,2.7-4.8,4.5c-0.2,0.3-0.7,0.4-1.1,0.2c-0.3-0.2-0.4-0.7-0.2-1.1l0,0c1.4-2,3.2-3.6,5.3-4.9c1.2-0.8,2.6-1.3,4-1.3 c1.2,0.1,2.3,0.6,3.2,1.3c2.6,1.9,4.3,4.9,4.6,8.2c0.2,1.5-0.1,3.1-0.6,4.5c-1,2.2-2.8,3.9-5,4.9c-2,0.9-4.2,1.6-6.3,2 C399.2,222.1,399.1,222.1,399,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368,225.1c-0.6,0-1.1,0-1.6-0.1c-2.6-0.2-5.2-0.9-7.6-2.1c-0.3-0.2-0.5-0.6-0.3-1c0.2-0.3,0.6-0.5,1-0.3 c2.2,1.1,4.6,1.7,7,1.9c5.7,0.4,11.2-1.5,16.4-5.7c0.3-0.3,0.8-0.2,1.1,0.1s0.2,0.8-0.1,1.1l0,0C377.9,223.9,372.1,225.1,368,225.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.3,216.2c-2.1,0-4.9-0.4-5.9-2.2c-1.4-2.8,3.5-11.8,4.5-13.5c0.2-0.3,0.6-0.5,1-0.3c0.4,0.2,0.5,0.6,0.3,1 c-2.3,4.1-5.2,10.6-4.4,12.1s4.6,1.6,6.9,1.2c0.4-0.1,0.8,0.2,0.9,0.6c0.1,0.4-0.2,0.8-0.6,0.8C370,216.1,369.1,216.2,368.3,216.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M410,209.3c-0.1,0-0.1,0-0.2,0c-0.4-0.1-0.6-0.5-0.5-0.9c3.9-13,4.1-23.3,0.5-34.3c-0.6-2.2-1.7-4.2-3.3-5.9 c-0.9-0.7-2-1.1-3.2-1.1c-0.4,0-0.8-0.1-1.3-0.1c-1.4-0.2-2.8-0.8-3.9-1.7l-0.9-0.6c-2.9-1.9-6.7-2.9-11.3-3.1 c-2.4-0.1-4.8,0.1-7.2,0.2c-2.9,0.3-5.9,0.3-8.8,0.2c-3.5-0.2-9.6-1.3-13.5-5.7c-0.5,3.6,0.9,7.3,3.5,9.8l2.1,1.9l-2.8-0.6 c-3-0.7-5.7-2.3-7.8-4.5c-1.5,3.6-1.4,7.7,0.2,11.2l0.1,0.3c0.3,0.5,0.5,1.1,0.7,1.6c0.2,0.9,0.1,1.9,0,2.8l-0.1,1 c-0.6,3-0.9,6.1-0.9,9.1c0,3.3,1.1,6.5,3.1,9.1c0.3,0.3,0.2,0.8-0.1,1.1c-0.3,0.3-0.8,0.2-1.1-0.1c0,0,0,0,0,0 c-2.7-3.1-3.4-7.2-3.5-10c0-3.2,0.3-6.3,0.9-9.4l0.1-0.9c0.2-0.7,0.2-1.5,0.1-2.2c-0.1-0.5-0.3-0.9-0.6-1.3l-0.1-0.3 c-2-4.3-1.9-9.3,0.3-13.6l0.5-1l0.7,0.9c1.4,1.7,3.2,3.1,5.2,4c-2.1-3.1-2.8-7.1-1.8-10.7l0.4-1.5l0.9,1.3c3.4,5,9.8,6.1,13.4,6.3 c2.9,0.1,5.8,0.1,8.6-0.2c2.4-0.2,4.9-0.3,7.3-0.2c5,0.1,9,1.2,12.1,3.3l0.9,0.6c0.9,0.8,2.1,1.3,3.3,1.4c0.4,0.1,0.8,0.1,1.2,0.1 c1.5,0,2.9,0.5,4,1.5c1.8,1.8,3.1,4.1,3.7,6.5c3.7,11.4,3.5,21.9-0.5,35.2C410.6,209.1,410.3,209.3,410,209.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    transform: "matrix(0.8371 -0.5471 0.5471 0.8371 -96.1515 161.398)",
    cx: 222.9,
    cy: 242.1,
    rx: 13.6,
    ry: 17.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    transform: "matrix(0.8371 -0.5471 0.5471 0.8371 -99.6321 158.5696)",
    cx: 216.4,
    cy: 246.5,
    rx: 14.5,
    ry: 18.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.6,264.5c-1.7,0-3.4-0.3-5-0.8c-9.3-3.4-15.2-12.5-14.6-22.3c0.3-7.3,6.5-13.1,13.8-12.8 c1.5,0.1,3,0.4,4.4,0.9c4.5,1.6,8.4,4.7,11,8.8l0,0c5.7,8.8,4.6,19.6-2.4,24.2C224.6,263.8,222.2,264.5,219.6,264.5z M213.2,230.1 c-2.2,0-4.4,0.6-6.3,1.8c-3.2,2.2-5.1,5.7-5.3,9.5c-0.5,9.2,5,17.6,13.6,20.8c3.6,1.3,7.6,0.9,10.9-1.1c6.4-4.2,7.2-14.1,2-22.1 c-2.4-3.8-6-6.7-10.2-8.1C216.3,230.4,214.7,230.1,213.2,230.1L213.2,230.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "215.8,253.4 206.1,239.3 207.4,238.4 216.2,251.3 224.9,245.1 225.7,246.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M219.5,261.8c-4.9,0-10.2-3-13.7-8.3c-4.9-7.5-4.1-16.7,1.7-20.5c3.1-1.9,6.8-2.2,10.2-0.9 c7.8,3.1,12.8,10.7,12.5,19.1c-0.1,3.6-1.9,6.9-4.9,8.9C223.5,261.2,221.5,261.8,219.5,261.8z M213.3,232.8c-1.8,0-3.5,0.5-4.9,1.4 c-5.1,3.4-5.7,11.6-1.3,18.4s12.2,9.6,17.4,6.2c2.6-1.8,4.1-4.7,4.2-7.8c0.2-3.8-0.8-7.5-2.9-10.6l0,0c-2-3.2-5-5.6-8.5-6.9 C215.9,233.1,214.6,232.8,213.3,232.8L213.3,232.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubsApproval);
export default __webpack_public_path__ + "static/media/SubsApproval.34a4fd8aa480c64046099f37e78e52b0.svg";
export { ForwardRef as ReactComponent };